export const Star = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.4588 10.2661L17.24 13.9064L18.5253 19.3505C18.5962 19.646 18.578 19.9559 18.4729 20.2411C18.3677 20.5263 18.1804 20.7739 17.9346 20.9526C17.6889 21.1314 17.3956 21.2333 17.0919 21.2455C16.7883 21.2577 16.4878 21.1796 16.2285 21.0211L11.4941 18.1074L6.75689 21.0211C6.49761 21.1787 6.19749 21.256 5.89434 21.2434C5.59118 21.2308 5.29854 21.1287 5.05327 20.9501C4.808 20.7715 4.62106 20.5243 4.51599 20.2396C4.41093 19.955 4.39243 19.6456 4.46283 19.3505L5.75283 13.9064L1.53408 10.2661C1.30467 10.0678 1.13876 9.80638 1.05707 9.51438C0.97537 9.22238 0.981511 8.91278 1.07472 8.62425C1.16793 8.33571 1.34408 8.08103 1.58117 7.89202C1.81826 7.703 2.10578 7.58802 2.40783 7.56143L7.93908 7.11518L10.0728 1.95143C10.1883 1.67001 10.3849 1.42929 10.6376 1.25987C10.8902 1.09046 11.1875 1 11.4917 1C11.7959 1 12.0933 1.09046 12.3459 1.25987C12.5986 1.42929 12.7951 1.67001 12.9106 1.95143L15.0435 7.11518L20.5747 7.56143C20.8774 7.58703 21.1657 7.70137 21.4037 7.89013C21.6416 8.07888 21.8186 8.33366 21.9124 8.62255C22.0062 8.91143 22.0126 9.22157 21.9309 9.5141C21.8492 9.80664 21.683 10.0686 21.4531 10.2671L21.4588 10.2661Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const CheckmarkCloud = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2.00488C12.6713 2.00488 13.332 2.17376 13.9209 2.49609C14.5097 2.81849 15.0084 3.28408 15.3701 3.84961C16.0283 3.70164 16.7134 3.72333 17.3613 3.91113C18.0091 4.09893 18.5992 4.44694 19.0762 4.92383C19.5531 5.40077 19.902 5.99086 20.0898 6.63867C20.2776 7.28652 20.2983 7.97179 20.1504 8.62988C20.7161 8.99159 21.1814 9.49017 21.5039 10.0791C21.8263 10.668 21.9951 11.3286 21.9951 12C21.9951 12.6714 21.8263 13.332 21.5039 13.9209C21.1815 14.5098 20.716 15.0084 20.1504 15.3701C20.2977 16.0271 20.2761 16.7106 20.0889 17.3574C19.9015 18.0043 19.5538 18.5936 19.0781 19.0703C18.6025 19.547 18.0146 19.8962 17.3682 20.085C16.7217 20.2737 16.0374 20.2963 15.3799 20.1504C15.0187 20.7181 14.5204 21.1859 13.9307 21.5098C13.3407 21.8337 12.6779 22.0029 12.0049 22.0029C11.332 22.0029 10.6699 21.8336 10.0801 21.5098C9.49015 21.1859 8.99112 20.7182 8.62988 20.1504C7.97286 20.2976 7.28933 20.2762 6.64258 20.0889C5.99568 19.9015 5.40641 19.5538 4.92969 19.0781C4.4531 18.6025 4.10375 18.0145 3.91504 17.3682C3.72634 16.7217 3.70463 16.0374 3.85059 15.3799C3.28065 15.0192 2.81071 14.5205 2.48535 13.9297C2.15999 13.3387 1.98926 12.6746 1.98926 12C1.98927 11.3255 2.1601 10.6622 2.48535 10.0713C2.81072 9.48033 3.28054 8.98087 3.85059 8.62012C3.70466 7.96279 3.72645 7.27919 3.91504 6.63281C4.10374 5.98632 4.45297 5.3976 4.92969 4.92188C5.40641 4.44615 5.99568 4.09848 6.64258 3.91113C7.2893 3.72386 7.97289 3.70238 8.62988 3.84961C8.99158 3.284 9.49023 2.81853 10.0791 2.49609C10.668 2.17368 11.3286 2.00492 12 2.00488ZM15.707 9.29297C15.3165 8.90244 14.6835 8.90244 14.293 9.29297L11 12.5859L9.70703 11.293C9.31651 10.9024 8.68349 10.9024 8.29297 11.293C7.90244 11.6835 7.90244 12.3165 8.29297 12.707L10.293 14.707C10.6835 15.0976 11.3165 15.0976 11.707 14.707L15.707 10.707C16.0976 10.3165 16.0976 9.68349 15.707 9.29297Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const CheckMark = () => {
  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.82841 6.65685L0 3.82845L0.942813 2.88559L2.82841 4.77125L6.59967 1L7.54247 1.94281L5.18544 4.29983L2.82841 6.65685Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ChevronDown = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 5L8 11L14 5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const RedCheck = () => {
  return (
    <img
      src="/icons/red-check.svg"
      width="30"
      height="30"
      alt=""
      draggable="false"
    />
  );
};

export const ArrowRolledUp = () => {
  return (
    <img
      src="/icons/arrow-rolled-up.svg"
      width="20"
      height="20"
      alt=""
      draggable="false"
    />
  );
};

export const GreenCheck = () => {
  return (
    <img
      src="/icons/green-check.svg"
      width="15"
      height="15"
      alt=""
      draggable="false"
    />
  );
};

export const ArrowLeftCircle = () => {
  return (
    <img
      src="/icons/arrow-left-circle.svg"
      width="32"
      height="32"
      alt=""
      draggable="false"
    />
  );
};

export const ArrowRightCircle = () => {
  return (
    <img
      src="/icons/arrow-right-circle.svg"
      width="32"
      height="32"
      alt=""
      draggable="false"
    />
  );
};

export const ArrowLeftCircleWhite = () => {
  return (
    <img
      src="/icons/arrow-left-circle-white.svg"
      width="32"
      height="32"
      alt=""
      draggable="false"
    />
  );
};

export const ArrowRightCircleWhite = () => {
  return (
    <img
      src="/icons/arrow-right-circle-white.svg"
      width="32"
      height="32"
      alt=""
      draggable="false"
    />
  );
};

export const Quotes = ({ ...rest }) => {
  return (
    <svg
      width="34"
      height="33"
      viewBox="0 0 34 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8014 6.32253C8.60171 9.54668 5.71306 13.2993 5.13542 17.5805C4.23618 24.2452 10.4092 27.5074 13.537 24.5763C16.6647 21.6453 14.7898 17.9249 12.525 16.908C10.2602 15.891 8.87514 16.2452 9.11674 14.8862C9.35834 13.5273 12.5805 9.75941 15.4113 8.00468C15.5991 7.85048 15.6706 7.55128 15.4898 7.32428C15.3708 7.17501 15.1375 6.88225 14.7898 6.44596C14.4858 6.06445 14.1946 6.07873 13.8014 6.32253Z"
        fill="var(--color)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.4906 6.32253C22.291 9.54668 19.4023 13.2993 18.8246 17.5805C17.9254 24.2452 24.0984 27.5074 27.2262 24.5763C30.354 21.6453 28.4791 17.9249 26.2142 16.908C23.9494 15.891 22.5643 16.2452 22.806 14.8862C23.0476 13.5273 26.2698 9.75941 29.1006 8.00468C29.2884 7.85048 29.3598 7.55128 29.1789 7.32428C29.06 7.17501 28.8267 6.88225 28.4791 6.44596C28.1751 6.06445 27.8838 6.07873 27.4906 6.32253Z"
        fill="var(--color)"
      />
    </svg>
  );
};

export const UpArrow = () => {
  return (
    <img
      src="/icons/up-arrow.svg"
      width="24"
      height="24"
      alt=""
      draggable="false"
    />
  );
};

export const DownArrow = () => {
  return (
    <img
      src="/icons/down-arrow.svg"
      width="24"
      height="24"
      alt=""
      draggable="false"
    />
  );
};

export const WhiteArrow = () => {
  return (
    <img
      src="/icons/white-arrow.svg"
      width="24"
      height="24"
      alt=""
      draggable="false"
    />
  );
};

export const ArrowTopRightCirclePrimary = () => {
  return (
    <img
      src="/icons/arrow-top-right-circle-primary.svg"
      width="128"
      height="128"
      alt=""
      draggable="false"
    />
  );
};

export const Create = () => {
  return (
    <img
      src="/icons/creer.svg"
      width="32"
      height="32"
      alt=""
      draggable="false"
    />
  );
};

export const Share = () => {
  return (
    <img
      src="/icons/partager.svg"
      width="32"
      height="32"
      alt=""
      draggable="false"
    />
  );
};

export const Questionnaire = () => {
  return (
    <img
      src="/icons/questionnaire.svg"
      width="32"
      height="32"
      alt=""
      draggable="false"
    />
  );
};

export const Selection = () => {
  return (
    <img
      src="/icons/selection.svg"
      width="32"
      height="32"
      alt=""
      draggable="false"
    />
  );
};

export const ArrowRightBlack = () => {
  return (
    <img
      src="/icons/arrow-right-black.svg"
      width="32"
      height="32"
      alt=""
      draggable="false"
    />
  );
};

export const ArrowRightPrimary = () => {
  return (
    <img
      src="/icons/arrow-right-primary.svg"
      width="32"
      height="32"
      alt=""
      draggable="false"
    />
  );
};

export const PlayIcon = ({ className = '' }) => {
  return (
    <img
      className={className}
      src="/icons/play-icon.svg"
      width="32"
      height="32"
      alt=""
      draggable="false"
    />
  );
};

export const PauseIcon = ({ className = '' }) => {
  return (
    <img
      className={className}
      src="/icons/pause-icon.svg"
      width="32"
      height="32"
      alt=""
      draggable="false"
    />
  );
};

export const PlusSign = () => {
  return (
    <img
      src="/icons/plus-sign.svg"
      width="40"
      height="40"
      alt=""
      draggable="false"
    />
  );
};

export const PlusSignBlack = () => {
  return (
    <img
      src="/icons/plus-sign-black.svg"
      width="40"
      height="40"
      alt=""
      draggable="false"
    />
  );
};

export const CreateWhite = () => {
  return (
    <img
      src="/icons/creer-white.svg"
      width="32"
      height="32"
      alt=""
      draggable="false"
    />
  );
};

export const ShareWhite = () => {
  return (
    <img
      src="/icons/partager-white.svg"
      width="32"
      height="32"
      alt=""
      draggable="false"
    />
  );
};

export const QuestionnaireWhite = () => {
  return (
    <img
      src="/icons/questionnaire-white.svg"
      width="32"
      height="32"
      alt=""
      draggable="false"
    />
  );
};

export const SelectionWhite = () => {
  return (
    <img
      src="/icons/selection-white.svg"
      width="32"
      height="32"
      alt=""
      draggable="false"
    />
  );
};

export const Formation = () => {
  return (
    <img
      src="/icons/formation.svg"
      width="60"
      height="60"
      alt=""
      draggable="false"
    />
  );
};

export const Ressources = () => {
  return (
    <img
      src="/icons/ressources.svg"
      width="60"
      height="60"
      alt=""
      draggable="false"
    />
  );
};

export const Community = () => {
  return (
    <img
      src="/icons/community.svg"
      width="60"
      height="60"
      alt=""
      draggable="false"
    />
  );
};

export const Crown = () => {
  return (
    <img
      src="/icons/crown.svg"
      width="60"
      height="60"
      alt=""
      draggable="false"
    />
  );
};

export const StarBlack = () => {
  return (
    <img
      src="/icons/star-black.svg"
      width="20"
      height="20"
      alt=""
      draggable="false"
    />
  );
};

export const StarPrimary = () => {
  return (
    <img
      className="level-up__blocks__item__icon"
      src="/icons/star-primary.svg"
      width="181"
      height="186"
      alt=""
      draggable="false"
    />
  );
};

export const SendIcon = () => {
  return (
    <img
      src="/icons/send.svg"
      width="75"
      height="56"
      alt=""
      draggable="false"
    />
  );
};

export const Check = () => {
  return (
    <img
      src="/icons/check.svg"
      width="15"
      height="10"
      alt=""
      draggable="false"
    />
  );
};

export const PrimaryCheck = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" fill="#FF5C57" />
      <path
        d="M10.546 17L6 12.2599L7.1365 11.0748L10.546 14.6299L17.8635 7L19 8.18503L10.546 17Z"
        fill="#FEFEFE"
      />
    </svg>
  );
};

export const YellowCheck = () => {
  return (
    <img
      src="/icons/yellow-check.svg"
      width="30"
      height="30"
      alt=""
      draggable="false"
    />
  );
};

export const BlackCheck = () => {
  return (
    <img
      src="/icons/black-check.svg"
      width="30"
      height="30"
      alt=""
      draggable="false"
    />
  );
};

export const GreyCross = () => {
  return (
    <img
      src="/icons/grey-cross.svg"
      width="20"
      height="20"
      alt=""
      draggable="false"
    />
  );
};

export const GreyDownArrow = () => {
  return (
    <img
      src="/icons/grey-down-arrow.svg"
      width="12"
      height="6"
      alt="grey down arrow"
      draggable="false"
    />
  );
};
